export const TopsportschoolLocatie = (props) => {
    return <div className="c-topsportschool-location">
        <h3>
            {props.data.name}
        </h3>
        <p>
            {props.data.address}
            <br />
            {props.data.city}
            <br />
            <a href={`tel:+${props.data.phone}`} title="Bel ons">
                <i className="fa fa-phone" aria-hidden="true"></i>
                {props.data.phone}
            </a>
            <br />
            <i className="fa fa-fax" aria-hidden="true" title="Fax"></i>
            {props.data.fax}
            <br />
            <a href={`mailto:${props.data.email}`} title="Mail ons">
                <i className="fa fa-envelope" aria-hidden="true"></i>
                {props.data.email}
            </a>
            <br />
            <a href={props.data.website} title="Bezoek onze website">
                <i className="fa fa-globe" aria-hidden="true"></i>
                {props.data.website}
            </a>
        </p>
    </div>
}